
import { CourseSchedule } from '@/types';
import { supabase } from '../utils';
import { mapScheduleToModel } from './types';

export async function getUpcomingCourses(): Promise<CourseSchedule[] | null> {
  try {
    console.log('Fetching upcoming course schedules from Supabase...');
    
    const { data, error } = await supabase
      .from('course_schedule')
      .select(`
        *,
        course:course_id (
          course_id,
          code,
          tech,
          category,
          course_description,
          days,
          price
        )
      `)
      .eq('status', 'upcoming')
      .order('start_date', { ascending: true });
      
    if (error) {
      console.error('Error fetching upcoming courses:', error);
      return null;
    }
    
    console.log('Fetched course schedules:', data);
    
    if (!data || data.length === 0) {
      console.log('No upcoming courses found');
      return [];
    }
    
    const formattedSchedules = data.map(schedule => {
      try {
        const startDate = new Date(schedule.start_date || '');
        const days = schedule.course?.days || 0;
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + days - 1);
        
        return mapScheduleToModel(schedule, startDate, endDate);
      } catch (itemError) {
        console.error('Error formatting schedule item:', itemError, schedule);
        return null;
      }
    }).filter(Boolean) as CourseSchedule[];
    
    console.log('Formatted schedules:', formattedSchedules);
    return formattedSchedules;
  } catch (error) {
    console.error('Error in getUpcomingCourses:', error);
    return null;
  }
}
